import React from 'react';

const Show = ({ children }) => {
  let when = null;
  let otherwise = null;

  React.Children.forEach(children, (child) => {
    if (child.props.isTrue) {
      when = child;
    } else if (!when) {
      otherwise = child;
    }
  });

  return when || otherwise || null;
};

Show.When = ({ isTrue, children }) => (isTrue ? children : null);
Show.Else = ({ children }) => children;

export default Show;
